import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/** Spec, §Error handling: a persistent top-of-page banner, not per-widget
 * spinners that never resolve. Any SupportApiService caller that hits a
 * network-level failure (not a 4xx from a resolved request) calls
 * reportApiError(); a subsequent success clears it. */
@Injectable({ providedIn: 'root' })
export class DegradedModeService {
  private subject = new BehaviorSubject<boolean>(false);
  apiUnreachable$ = this.subject.asObservable();

  reportApiError(): void {
    this.subject.next(true);
  }

  reportApiSuccess(): void {
    this.subject.next(false);
  }
}
